/**
 * Frontend locale config, built from the generated exposed-config artifact
 * (DEN-135) — `SUPPORTED_LOCALES`/`DEFAULT_LOCALE`/`LOCALE_ENDONYMS` all come
 * from `config/default.yml`'s `i18n.*` keys (see `src/i18n/locales.ts` for
 * the backend's own copy; the two no longer share a module — `config` reads
 * the filesystem at import time, so the backend module can't be imported
 * from frontend code, DEN-121).
 */
import type { Locale } from '../../shared/preferences';
import { exposedConfig } from '../generated-config';

export type SupportedLocale = Locale;

export const SUPPORTED_LOCALES: readonly SupportedLocale[] =
  exposedConfig.i18n.supportedLocales;

export function isSupportedLocale(value: unknown): value is SupportedLocale {
  return (
    typeof value === 'string' &&
    (SUPPORTED_LOCALES as readonly string[]).includes(value)
  );
}

/** Default + bootstrap + runtime fallback. */
export const DEFAULT_LOCALE: SupportedLocale = exposedConfig.i18n.defaultLocale;

export const LOCALE_ENDONYMS: Record<SupportedLocale, string> =
  exposedConfig.i18n.localeEndonyms;
